import { DataStatesWrapper } from "shared/ui/data-states-wrapper";
import { clsxMerge } from "shared/lib/helpers";
import CenteredSpinner from "shared/ui/spinners/centered-spinner";

import { DIALER_CALL_STATUS } from "@/constants/dialer";
import { useAccountDetailsContext } from "@/modules/pipeline/account-details/context";
import { useDialerCallStatus } from "@/hooks/dialer/use-dialer-call-status";

import { AccountTopSectionContent } from "./content";

export const ContentWrapper = () => {
  const { accountDetailsApi, campaign, account, accountStatus, contacts } =
    useAccountDetailsContext();

  return (
    <DataStatesWrapper
      viewName="Account state"
      api={accountDetailsApi}
      loading={<CenteredSpinner className="h-[135px]" />}
    >
      <div
        className={clsxMerge(
          "h-[135px] w-full",
          "bg-gradient-to-t from-[#DADADA] to-[#F4F4F4]"
        )}
      >
        {accountStatus && (
          <AccountTopSectionContent
            campaign={campaign}
            account={account}
            accountStatus={accountStatus}
            contacts={contacts}
          />
        )}
      </div>
    </DataStatesWrapper>
  );
};

export const AccountTopSection = () => {
  const callStatus = useDialerCallStatus();

  if (callStatus !== DIALER_CALL_STATUS.BEFORE) {
    return null;
  }

  return <ContentWrapper />;
};
